import { css } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography, useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';
import { ErrorIcon } from '@coursera/cds-icons';

import { Card } from 'bundles/program-loggedin-shared/components/Card';

import _t from 'i18n!nls/degree-home';

const styles = {
  grid: css`
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
  icon: (theme: Theme) => css`
    margin-top: ${theme.spacing(32)};
  `,
  text: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(32)};
    font-weight: 600;
    font-size: 20px;
  `,
};

const ErrorCard = ({ hideBorder = false }) => {
  const theme = useTheme();
  const content = (
    <Grid css={styles.grid}>
      <ErrorIcon style={{ marginTop: theme.spacing(32) }} size="large" color="error" />
      <Typography variant="h2semibold" component="p" style={{ marginBottom: theme.spacing(32) }}>
        {_t('Failed to fetch data')}
      </Typography>
    </Grid>
  );

  return hideBorder ? content : <Card>{content}</Card>;
};

export default ErrorCard;
